import React, { type ReactElement } from 'react';

import { ProButton } from '@components/Button/variants';
import LogoTIProText from '@components/Images/Rebranding/LogoTIProText';
import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import { PHONE_IMAGE_URL } from './constants';
import { ClusterHeaderProps } from './interfaces';

const ClusterHeader = ({
  dollarSavings,
  description,
  proOfferCode,
  upgradePath,
}: ClusterHeaderProps): ReactElement => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.Header,
  });

  const handleUpgradeClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.Upgrade, offerCode: proOfferCode }));
  };

  return (
    <header className="relative flex flex-col items-center gap-32 border-0 border-b border-solid border-pro-gold pb-64 sm:flex-row sm:items-start sm:gap-[84px] md:justify-center md:gap-48 md:pb-[60px] lg:gap-64">
      <div className="md:max-w-[512px]">
        <h1 className="font-suisse-works text-headline-xs sm:mt-0 md:text-headline-sm">
          Upgrade to{' '}
          <LogoTIProText
            aria-label="The Information Pro"
            className="mt-24 block sm:max-w-[400px]"
          />
        </h1>
        <p className="mb-0 mt-24 font-suisse-neue text-body-lg font-normal text-grayscale-charcoal md:text-subheadline-md">
          {description}
        </p>
        <ProButton
          as="link"
          className="mt-32 sm:max-w-[330px]"
          href={upgradePath}
          onClickCapture={handleUpgradeClick}
          fullWidth
        >
          Upgrade
        </ProButton>
        <span className="mt-8 block text-center font-suisse-screen text-caption-md font-medium text-grayscale-gray sm:max-w-[330px]">
          Save {dollarSavings} on your first year
        </span>
      </div>
      <LazyImgixImage
        className="hidden w-full max-w-[157px] sm:mr-64 sm:block md:max-w-[167px] lg:mr-[50px]"
        src={PHONE_IMAGE_URL}
        visibleByDefault
      />
    </header>
  );
};

export default ClusterHeader;
